export default function Sidebar() {
  const sidebarAccordionBtn = document.querySelector('.sidebar__accordion-action-btn');
  if (sidebarAccordionBtn) {
    sidebarAccordionBtn.addEventListener('click', function (e) {
      sidebarAccordionBtn.closest('.sidebar__main').classList.toggle('sidebar__open');
    });
  }
}
